import { Autocomplete, Box, Stack, TextField, Typography, Checkbox, FormControlLabel } from "@mui/material";
import React from "react";
import { StringField } from "../ConfigFields/StringField";
import { EnumField } from "../ConfigFields/EnumField";
import { formatTitle } from "../utils";
import { ArrayObjectField } from "../ConfigFields/ArrayObjectField";
import { NumberField } from "../ConfigFields/NumberField";
import { Close } from "@mui/icons-material";
import { ColorsConstants } from "../../../../cssUtils/constants";

const TextMessagePreset = ({ schema, config, handleConfigChange }) => {
  const action = config["action"] || "none";
  console.log(schema["properties"], "config ufh")
  return (
    <Stack spacing={3}>
      <StringField
        fieldKey={"message_text"}
        schema={schema?.properties["message_text"] || {}}
        value={config["message_text"]}
        required={true}
        onChange={(val) => handleConfigChange("message_text", val)}
      />

      <EnumField
        label={formatTitle("action")}
        schema={schema?.properties["action"] || {}}
        value={config["action"] || ""}
        onChange={(val) => handleConfigChange("action", val)}
      />

      {action === "buttons" && (
        <Box>
          <Typography sx={{ fontWeight: "bold", mb: 2 }}>
            {formatTitle("buttons")}
          </Typography>

          <Box sx={{ px: 1 }}>
            {config["buttons"]?.map((item, index) => (
              <Box
                key={index}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  borderBottom: "1px solid #ddd",
                  gap: 1,
                  mb: 1.5,
                  pb: 1.5,
                }}
              >
                <Stack spacing={2} sx={{ flex: 1 }}>
                  <TextField
                    key={"title"}
                    label={formatTitle("title")}
                    type={"text"}
                    value={item["title"] ?? ""}
                    onChange={(e) =>
                      handleConfigChange(
                        "buttons",
                        config["buttons"].map((b, i) =>
                          i === index
                            ? {
                                ...b,
                                title: e.target.value,
                                payload: e.target.value
                                  .replaceAll(" ", "_")
                                  .toLowerCase(),
                              }
                            : b,
                        ),
                      )
                    }
                    size="small"
                    fullWidth
                  />
                </Stack>

                <Box
                  sx={{ cursor: "pointer" }}
                  onClick={() => {
                    const updated = config["buttons"].filter(
                      (_, i) => i !== index,
                    );
                    handleConfigChange("buttons", updated);
                  }}
                >
                  <Close />
                </Box>
              </Box>
            ))}

            <Box
              onClick={() => {
                const emptyItem = {
                  title: "",
                  payload: "",
                };

                handleConfigChange("buttons", [
                  ...(config["buttons"] || []),
                  emptyItem,
                ]);
              }}
              sx={{
                cursor: "pointer",
                color: ColorsConstants.primaryBlue100,
                fontWeight: "bold",
              }}
            >
              + Add
            </Box>
          </Box>
        </Box>
      )}

      {action === "static_url" && (
        <Stack>
          <Typography sx={{ fontWeight: "bold", mb: 1 }}>Static URL</Typography>

          <Stack gap={2} sx={{ px: 0.5 }}>
            <TextField
              fullWidth
              label={formatTitle("title")}
              placeholder={"Enter text for the button"}
              value={config?.static_url?.title || ""}
              onChange={(e) =>
                handleConfigChange("static_url", {
                  ...config?.static_url,
                  title: e.target.value,
                })
              }
              required={true}
              size="small"
              sx={{
                "& .MuiOutlinedInput-root.Mui-focused fieldset": {
                  borderColor: "primary.main",
                },
              }}
            />

            <TextField
              fullWidth
              label={"URL"}
              placeholder={"Enter url, example: https://example.com/test"}
              value={config?.static_url?.url || ""}
              onChange={(e) =>
                handleConfigChange("static_url", {
                  ...config?.static_url,
                  url: e.target.value,
                })
              }
              required={true}
              size="small"
              sx={{
                "& .MuiOutlinedInput-root.Mui-focused fieldset": {
                  borderColor: "primary.main",
                },
              }}
            />
          </Stack>
        </Stack>
      )}
      {action === "menu" && (
        // <ArrayObjectField
        //   label={formatTitle(orderedFields[3])}
        //   schema={schema?.properties[orderedFields[3]] || {}}
        //   value={config[orderedFields[3]] || []}
        //   onChange={(val) => handleConfigChange(orderedFields[3], val)}
        // />
        <Typography>Coming Soon...</Typography>
      )}

      <NumberField
        fieldKey={"delay"}
        schema={schema?.properties["delay"] || {}}
        value={config["delay"]}
        required={false}
        onChange={(val) => handleConfigChange("delay", val)}
      />

      {schema?.properties?.save_user_response && (
        <FormControlLabel
          control={
            <Checkbox
              checked={
                config?.save_user_response ??
                schema?.properties?.save_user_response?.default ??
                false
              }
              onChange={(e) =>
                handleConfigChange("save_user_response", e.target.checked)
              }
            />
          }
          label={
            schema?.properties?.save_user_response?.description
              ? schema.properties.save_user_response.description
              : formatTitle("save_user_response")
          }
        />
      )}
    </Stack>
  );
};

export default TextMessagePreset;
